import { Column } from '@access-erp/common';
import { useMemo } from 'react';

import { getHeaderColumns } from '../columns/headerColumns';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { browserHistory } from '@/routing/browserHistory';

export interface UseTransactionTableColumnsReturn {
  headerColumns: Column<any>[];
  goToPurchaseOrdersBySearch: (searchText?: string) => void;
}

export const useColumns = (): UseTransactionTableColumnsReturn => {
  const goToPurchaseOrdersBySearch = (searchText?: string) => {
    const link = searchText
      ? `${window.location.pathname}?search=${encodeURIComponent(searchText)}`
      : `${window.location.pathname}`;
    browserHistory.push(getParameterizedLink(link));
  };
  return useMemo(() => {
    const headerColumns = getHeaderColumns();
    return {
      headerColumns,
      goToPurchaseOrdersBySearch,
    };
  }, []);
};
